




































import {mapGetters} from 'vuex';
import vue, {PropType} from 'vue';
import {AdvertType} from '#/Advert';

export default vue.extend({
  name: 'AdvertCreationTypeSelection',

  props: {
    customTitle: {
      type: String as PropType<string>,
    },
    errors: {
      required: true,
      type: Array as PropType<string[]>,
    },
    multi: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    type: {
      type: Object as PropType<AdvertType>,
    },
    types: {
      type: Array as PropType<AdvertType[]>,
    },
  },

  data: (): { helpDisplay: boolean } => ({
    helpDisplay: false,
  }),

  computed: {
    ...mapGetters([
      'advertTypeItems',
    ]),
    title(): string {
      return this.customTitle || this.$t('advert.creation.titles.type') as string;
    },
  },

  methods: {
    hasType(adType: AdvertType): boolean {
      return this.multi
          ? this.types.includes(adType)
          : this.type === adType;
    },
    /**
     * Ajoute ou enlève de la sélection des type d'annonce, le type passé en argument
     *
     * @param {AdvertType} adType - la constante associée au type d'annonce
     */
    onSelectType(adType: AdvertType): void {
      if (this.multi) {
        const typeIndex = this.types.indexOf(adType);
        const nextSelection = typeIndex < 0
            ? [...this.types, adType]
            : [
              ...this.types.slice(0, typeIndex),
              ...this.types.slice(typeIndex + 1),
            ];
        this.$emit('update:types', nextSelection);
      } else {
        if (this.type !== adType) {
          this.$emit('update:type', adType);
        }
      }
    },
  },
});
